import { Message } from 'element-ui'

export function diaMessage(msg, icon = 'error', time = "3") {
    if (icon == 'error') {
        this.$layer.msg('<p><img class="mylayer" src="' + require('@/assets/images/error-icon.png') + '"/>' + msg + '</p>', { time })
    } else if (icon === 'wrong') {
        this.$layer.msg('<p><img class="mylayer" src="' + require('@/assets/images/wrong.png') + '"/>' + msg + '</p>', { time })
    } else {
        this.$layer.msg('<p><img class="mylayer" src="' + require('@/assets/images/success-icon.png') + '"/>' + msg + '</p>', { time })
    }

}
export function Mymessage(msg, type = 'error', duration = 3000) {
    Message({
        message: msg,
        type,
        duration
    })
}